import clsx from "clsx";
import PropTypes from "prop-types";

// MUI
import { Button, InputAdornment, Typography } from "@mui/material";

// Helpers
import { isNumeric } from "@/Common/helpers/Verifications/numbers";
import { numberSuffix } from "@/Common/helpers/number";
import { getDecimalPart } from "./inputUtils";

const getDecimalPlaces = (value, decimals = 0) => {
	const decimalPart = getDecimalPart(value, decimals);
	return decimalPart.slice(1);
};

const isInvalidEndAdornment = (value, dashed = false) => (value && !isNumeric(value)) || value === "-" || dashed;

export default function EndAdornment(props) {
	const { type, value, isFixed, decimals, dashed, disabled, error, hideButton } = props;
	const isShownText = type?.toUpperCase() === "ORDINAL" || isFixed;

	if (isInvalidEndAdornment(value, dashed)) {
		return null;
	}

	return (
		<InputAdornment position="end" sx={{ height: "100%" }}>
			{isShownText ? (
				<Typography
					sx={{
						fontFamily: "var(--font-family-v2)",
						fontSize: "14.5px",
						color: disabled ? "var(--read-only-gray-color)" : "var(--text-color)",
						backgroundColor: disabled ? "var(--input-disabled-color)" : "transparent",
						paddingRight: "5px",
						marginLeft: "-7px",
						height: "100%",
						lineHeight: 2.2,
					}}
				>
					{isFixed ? getDecimalPlaces(value, decimals) : numberSuffix(value)}
				</Typography>
			) : (
				<Button
					title={disabled ? "" : "No decimal places allowed"}
					className={clsx("!leading-[inherit]", {
						hidden: hideButton,
						"no-here": hideButton,
						"end-button": true,
						"disabled-button": disabled,
						"error-end-button": error,
					})}
					disableRipple
					disabled={disabled}
				>
					{getDecimalPlaces(value, decimals)}
				</Button>
			)}
		</InputAdornment>
	);
}

EndAdornment.propTypes = {
	type: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	isFixed: PropTypes.bool,
	decimals: PropTypes.number,
	dashed: PropTypes.bool,
	disabled: PropTypes.bool,
	error: PropTypes.bool,
	hideButton: PropTypes.bool,
};
